<svg xmlns="http://www.w3.org/2000/svg" [ngClass]="'icon ' + iconCls" viewBox="0 0 16.62 16.62">
	<path
		class="icon__path"
		d="M502.766,407.143a8.31,8.31,0,1,0,8.311,8.308A8.308,8.308,0,0,0,502.766,407.143Zm4.712,6.1-4.237,5.3a5.066,5.066,0,0,1-.422.455.949.949,0,0,1-.548.221h-.021a2.571,2.571,0,0,1-.428-.059,2.91,2.91,0,0,1-.715-.5l-3.029-3.031a.311.311,0,0,1,0-.439l1.2-1.2a.313.313,0,0,1,.439,0l2.117,2.116a.273.273,0,0,0,.415-.023l3.43-4.287a.311.311,0,0,1,.437-.048l1.32,1.057A.311.311,0,0,1,507.479,413.248Z"
		transform="translate(-494.457 -407.143)"
	/>
</svg>
